import React from "react";
import PageHero from "@/components/PageHero";
import Manifesto from "@/components/Manifesto";
import QuoteCTA from "@/components/QuoteCTA";
import { Reveal } from "@/components/Reveal";

const FAMILY_IMG =
  "https://images.unsplash.com/photo-1577896850715-ed0b7e3ece57?crop=entropy&cs=srgb&fm=jpg&w=1200&q=72&auto=format";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="About"
        title="Local family."
        italic="Kinetico backing."
        description="Vanguard Water Systems is family-owned and family-run. We install and service Kinetico systems across Northern Utah and Southern Idaho — because we live here too."
        testId="about-hero"
      />

      <section className="py-32 lg:py-40 px-6 lg:px-10">
        <div className="mx-auto max-w-[1400px]">
          <div className="grid grid-cols-12 gap-y-16 lg:gap-x-10 items-center">
            <Reveal className="col-span-12 lg:col-span-6" testId="about-story">
              <div className="text-[11px] uppercase tracking-[0.35em] text-[color:var(--blue)] mb-6">
                Our story
              </div>
              <h2 className="font-display font-semibold text-[clamp(2rem,4.5vw,4rem)] leading-[1.05] text-white">
                The right water<br />is <span className="font-editorial italic font-normal text-[color:var(--blue)]">quiet water.</span>
              </h2>
              <div className="mt-8 space-y-6 text-[15.5px] leading-[1.8] text-[color:var(--muted)] font-body max-w-lg">
                <p>
                  Vanguard Water Systems was founded to bring one specific thing to Northern Utah and Southern Idaho: honest advice about what's actually in your water — and the best equipment on earth to fix it.
                </p>
                <p>
                  We chose to be the authorized Kinetico dealer for the region because Kinetico builds the only water systems we'd trust in our own homes: non-electric, twin-tank, engineered to outlive their warranties.
                </p>
                <p>
                  Vanguard Water Systems is based here in Northern Utah — same water, same neighborhoods, same schools. When we say we'll be there in the morning, we're already down the street.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.15} className="col-span-12 lg:col-span-6" y={80}>
              <div className="relative product-frame-alt overflow-hidden aspect-[4/5] lg:aspect-[3/4] bg-[color:var(--surface)]">
                <img
                  src={FAMILY_IMG}
                  alt="Family enjoying clean water at home"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--bg)]/70 via-transparent to-transparent" />
                <div className="absolute bottom-8 left-8 right-8">
                  <div className="font-editorial italic text-white/95 text-2xl lg:text-3xl leading-tight">
                    &ldquo;We treat every install like it's going into our own kitchen.&rdquo;
                  </div>
                  <div className="mt-4 text-[11px] uppercase tracking-[0.3em] text-[color:var(--blue)]">
                    — Vanguard Water Systems
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <Manifesto />
      <QuoteCTA />
    </div>
  );
}
